import { render, staticRenderFns } from "./ReceiveBatch.vue?vue&type=template&id=23112492"
import script from "./ReceiveBatch.vue?vue&type=script&lang=js"
export * from "./ReceiveBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports